import '../css/App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DataProvider } from "./shared/DataProvider";
import AboutUs from './pages/AboutUs';
import Login from './pages/Login';
import Logout from './pages/Logout';
import FAQ from './pages/FAQ';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from "./pages/TermsOfService";
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Main from './components/common/Main';
import Directory from "./pages/Directory";
import ServiceCompanyLanding from "./pages/ServiceCompanyLanding";
import AgentLanding from "./pages/AgentLanding";
import ServiceCompanyProfile from "./pages/ServiceCompanyProfile";
import ComingSoon from "./pages/ComingSoon";
import ServiceCompanyRegistration from "./pages/ServiceCompanyRegistration";
import ServiceCompanyCreatePassword from "./pages/ServiceCompanyCreatePassword";
import ServiceCompanyTrades from "./pages/ServiceCompanyTrades";
import ServiceCompanyDetails from "./pages/ServiceCompanyDetails";
import ReferServiceCompany from "./pages/ReferServiceCompany";
import AdminServiceCompanyDashboard from "./pages/AdminServiceCompanyDashboard";
import AdminServiceCompanyEdit from "./pages/AdminServiceCompanyEdit";
import ResetPassword from "./pages/ResetPassword";
import AdminContactUsFormsDashboard from "./pages/AdminContactUsFormsDashboard";
import AdminContactUsFormEdit from "./pages/AdminContactUsFormEdit";
import AdminServiceCompanyReferralEdit from "./pages/AdminServiceCompanyReferralEdit";
import AdminServiceCompanyReferralsDashboard from "./pages/AdminServiceCompanyReferralsDashboard";

function App() {
  return (
    <DataProvider>
      <Router>
        <Header />
        <Main>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/service-company-registration" element={<ServiceCompanyRegistration />} />
            <Route path="/service-company-create-password" element={<ServiceCompanyCreatePassword />} />
            <Route path="/service-company-trades" element={<ServiceCompanyTrades />} />
            <Route path="/service-company-details" element={<ServiceCompanyDetails />} />
            <Route path="/service-company/:id" element={<ServiceCompanyProfile />} />
            <Route path="/service-company" element={<ServiceCompanyLanding />} />
            <Route path="/agent" element={<AgentLanding />} />
            <Route path="/refer-service-company" element={<ReferServiceCompany />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/admin/service-company/:id" element={<AdminServiceCompanyEdit />} />
            <Route path="/admin/service-companies" element={<AdminServiceCompanyDashboard />} />
            <Route path="/admin/contact-form/:id" element={<AdminContactUsFormEdit />} />
            <Route path="/admin/contact-forms" element={<AdminContactUsFormsDashboard />} />
            <Route path="/admin/service-company-referral/:id" element={<AdminServiceCompanyReferralEdit />} />
            <Route path="/admin/service-company-referrals" element={<AdminServiceCompanyReferralsDashboard />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Main>
        <Footer />
      </Router>
    </DataProvider>
  );
}

export default App;
